import { makeStyles, tokens } from "@fluentui/react-components";

export const useShadowStyle = makeStyles({
	right: {
		boxShadow: `inset calc(var(--shadow-size) * -1) 0px 10px -10px ${tokens.colorNeutralShadowAmbient}`,
	},
	left: {
		boxShadow: `inset var(--shadow-size) 0px 10px -10px ${tokens.colorNeutralShadowAmbient}`,
	},
});
